module.exports = __webpack_public_path__ + "static/media/share_person7.b25b8823.png";